export enum MailingSplitTestStatusTypeEnum {
  Created = 'created',
  Running = 'running',
  Failed = 'failed',
  Completed = 'completed',
  Interrupted = 'interrupted',
}
